// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9c2d9962","239":"fb4b18a3","455":"0a8d409c","557":"d8835d57","762":"0f8afc78"}[chunkId] + ".chunk.js";
};